import { useEffect, useRef } from "react";

export const Waveform = ({ analyser, active }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let raf;
    const bars = 48;
    const data = analyser ? new Uint8Array(analyser.frequencyBinCount) : null;
    const draw = () => {
      const { width, height } = canvas;
      ctx.clearRect(0, 0, width, height);
      if (analyser && active) analyser.getByteFrequencyData(data);
      const w = width / bars;
      for (let i = 0; i < bars; i++) {
        const v = analyser && active ? data[Math.floor((i / bars) * data.length * 0.7)] / 255 : 0.05 + 0.03 * Math.sin(Date.now() / 600 + i / 3);
        const h = Math.max(4, v * height * 0.9);
        const grad = ctx.createLinearGradient(0, height / 2 + h / 2, 0, height / 2 - h / 2);
        grad.addColorStop(0, "#B39130");
        grad.addColorStop(1, "#F0D375");
        ctx.fillStyle = grad;
        ctx.beginPath();
        ctx.roundRect(i * w + w * 0.25, height / 2 - h / 2, w * 0.5, h, 4);
        ctx.fill();
      }
      raf = requestAnimationFrame(draw);
    };
    draw();
    return () => cancelAnimationFrame(raf);
  }, [analyser, active]);

  return <canvas ref={canvasRef} width={720} height={140} className="w-full h-28 sm:h-36" data-testid="recorder-waveform" />;
};
